import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { EnvironmentService, RealmData, VersionData } from '../../services/environment.service';
import { PgUserMenuComponent, PgUserMenuData } from '../pg-user-menu/pg-user-menu.component';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { PgTasksViewComponent } from '../pg-tasks-view/pg-tasks-view.component';
import { PgHeaderStatusService, PgHeaderStatus, PgHeaderStatusBack } from '../pg-header-status.service';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-pg-header',
    templateUrl: './pg-header.component.html',
    styleUrls: ['./pg-header.component.scss'],
    standalone: false
})
export class PgHeaderComponent implements OnInit {
    constructor(private router:Router, private environmentService:EnvironmentService, private authService:AuthService, private pgHeaderStatusService:PgHeaderStatusService, private localizationService:LocalizationService) { }

    @Input() menuElements:Array<PgUserMenuData>;
    @Input() requiredRealms:boolean;
    @Input() alwaysShow:boolean;

    @Input() name:string;
    @Input() appName:string;
    @Input() logo:string;
    @Input() color:string;
    @Input() back:PgHeaderStatusBack;
    @Input() backOnLogo:boolean;

    @Input() noTasks:boolean;
    @Input() noUser:boolean;
    @Input() noChat:boolean;

    isHidden = true;

    status:PgHeaderStatus = null;

    newFrontendVersion:VersionData = null;
    animateNewFrontendVersion = false;

    isSwitchingLanguage = false;

    ngOnInit() {
        if(this.alwaysShow) this.isHidden = false;

        this._generateHeaderStatus()

        this.environmentService.publicRealmChange.subscribe(() => {
            this._generateHeaderStatus()
        })

        this.pgHeaderStatusService.statusChange.subscribe(() => {
            this._generateHeaderStatus()
        })

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this._generateHeaderStatus()
            }
        })

        this.environmentService.frontendVersionChange.subscribe((data) => {
            if(this.newFrontendVersion == null) {
                setInterval(() => {
                    this.animateNewFrontendVersion = true;
                    setTimeout(() => {
                        this.animateNewFrontendVersion = false;
                    }, 250)
                }, 30000)
            }

            this.newFrontendVersion = data
        })

        this.localizationService.currentLanguageChange.subscribe((status) => {
            this.isSwitchingLanguage = true;
            setTimeout(() => {
                this.isSwitchingLanguage = false;
            }, 250)
        })
    }

    reloadApplication() {
        window.location.reload()
    }

    private _setDefaultStatus() {
        this.status = {}

        if(this.name) {
            this.status.name = this.name;
        }
        else {
            if(this.environmentService.environment.ForceRealm != null) {
                this.status.name = this.environmentService.publicRealm?.name;
            }
            else {
                if(this.environmentService.environment.AppName != null && this.environmentService.environment.AppName != '') {
                    this.status.name = this.environmentService.environment.AppName;
                }

                if(!this.environmentService.ignoreRealm) {
                    let _realm:RealmData = null;
                    
                    if(this.authService.isLoggedIn()) {
                        _realm = this.authService.user.realm;
                    }
                    else {
                        _realm = this.environmentService.publicRealm;
                    }
                
                    if(_realm != null) {
                        if(_realm.id == null) {
                            //this.routeSubName = 'Global'
                        }
                        else {
                            this.status.subName = _realm.name;
                        }
                    }
                }
            }
        }

        this.status.appName = this.appName;
        this.status.logo = this.logo || 'assets/images/poistory.png'
        this.status.back = this.back
    }

    isLoggedIn() {
        return this.authService.isLoggedIn(true);
    }

    isFullyLoggedIn() {
        return this.authService.isLoggedIn()
    }

    private _getCurrentRoute() {
        let _currentRoute = this.router.routerState.snapshot.root;
        while(_currentRoute.firstChild != null) _currentRoute = _currentRoute.firstChild;

        return _currentRoute
    }

    private _generateHeaderStatus() {
        this._setDefaultStatus()

        let _customizationStatus:PgHeaderStatus = {};

        if(this.pgHeaderStatusService.status != null) {
            _customizationStatus = JSON.parse(JSON.stringify(this.pgHeaderStatusService.status));
        }

        let _currentRoute = this._getCurrentRoute();
        if(_currentRoute.data?.header != null) {
            for(let i in _currentRoute.data.header) {
                let _val = _currentRoute.data.header[i]

                if(typeof _val == 'function') {
                    _val = _val(this.environmentService, _currentRoute.params)
                }
                
                if(_val != null) _customizationStatus[i] = _val
            }
        }

        if(Object.keys(_customizationStatus).length == 0) {
            if(this.alwaysShow) this.isHidden = false;
            else this.isHidden = true;
        }
        else {
            this.isHidden = false;

            for(let i in _customizationStatus) {
                this.status[i] = _customizationStatus[i]
            }
        }

        if(typeof this.status.back == 'string') {
            this.status.back = {
                url: this.status.back,
                text: this.status.back
            }
        }
    }

    goRouteBack() {
        let _url:string = (this.status.back as any)?.url;

        if(_url != null) {
            let _currentRoute = this._getCurrentRoute();

            if(_currentRoute.params != null) {
                for(let i in _currentRoute.params) {
                    _url.replace(':' + i, _currentRoute.params[i])
                }
            }

            if(/^https?:\/\//.test(_url)) {
                window.location.href = _url;
            }
            else {
                this.router.navigate([_url.split('#')[0]], { fragment: _url.split('#')[1] })
            }
        }
    }

    isChatEnabled() {
        return !this.noChat && this.environmentService.isWebsocketEnabled();
    }

    isChatVisible = false;

    chatUnreadCount = 0;
    chatNotificationCount = 0;

    @ViewChild(NgbDropdown) chatComponent:NgbDropdown;

    @ViewChild(PgTasksViewComponent) taskViewComponent:PgTasksViewComponent;
    @ViewChild(PgUserMenuComponent) userMenuComponent:PgUserMenuComponent;

    onOpenChange(component:string, value:boolean) {
        if(value) {
            if(component != 'chat') this.isChatVisible = false;

            if(component != 'task-view') this.taskViewComponent?.dropdownComponent?.close()
            if(component != 'user-menu') this.userMenuComponent?.dropdownComponent?.close()
        }
    }

    cleanReadableURL(val:string) {
        return val.replace(/^http.*:\/\//, '').replace(/^www\./, '').replace(/\/.*/, '')
    }
}
